var map = {
	"./033-bm.webp": 1255,
	"./033-cn.webp": 1256,
	"./033.webp": 1257,
	"./13-bm.webp": 1258,
	"./13-cn.webp": 1259,
	"./13.webp": 1260,
	"./3-bm.webp": 1261,
	"./3-cn.webp": 1262,
	"./3.webp": 1263,
	"./angpao-bm.webp": 1264,
	"./angpao-cn.webp": 1265,
	"./angpao.webp": 1266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1254;